import {
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    SxProps,
    Theme,
    Typography,
} from "@mui/material";
import { ReactNode, useState } from "react";

import SlideHeading from "./slideHeader";

const BlockQuote = ({
    imgSrc = false,
    children,
}: {
    imgSrc?: false | string;
    children: ReactNode;
}) => (
    <Typography
        variant="body2"
        color="textSecondary"
        style={{
            display: "block",
            float: "right",
            width: "250px",
            borderBottom: "1px solid rgba(0,0,0,0.54)",
            borderTop: "1px solid rgba(0,0,0,0.54)",
            padding: "7px 5px 7px 60px",
            background: imgSrc ? `url(${imgSrc}) left center no-repeat` : "none",
            backgroundSize: "50px 50px",
            fontWeight: "200",
            fontSize: "16px",
            marginLeft: "4px",
        }}
    >
        {children}
    </Typography>
);

const ListSlide = ({
    header,
    imgUrl,
    color,
    listItems,
    listIcon,
    sx = {},
}: {
    header: string;
    imgUrl: string;
    color: string;
    listItems: any[];
    listIcon: ReactNode;
    sx?: SxProps<Theme>;
}) => {
    const [currentLink, setCurrentLink] = useState(0);
    return (
        <Grid container>
            <Grid item sm={3} xs={12}>
                <img
                    style={{
                        width: "100%",
                        display: "block",
                        margin: "auto",
                        maxWidth: 126,
                    }}
                    alt={header}
                    src={imgUrl}
                />
                <List dense>
                    {listItems.map((li, i) => (
                        <ListItem key={"li" + i} button onClick={() => setCurrentLink(i)}>
                            <ListItemIcon
                                style={{
                                    color: i === currentLink ? color : "rgba(0,0,0,0.54)",
                                }}
                            >
                                {listIcon}
                            </ListItemIcon>
                            <ListItemText
                                primary={li.title.toUpperCase()}
                                style={{ color: i === currentLink ? color : "inherit" }}
                            />
                        </ListItem>
                    ))}
                </List>
            </Grid>
            <Grid item sm={9} xs={12}>
                <SlideHeading color={color} sx={sx}>
                    {header}
                </SlideHeading>
                <Typography variant="body1">
                    <strong>{listItems[currentLink].title}</strong>
                </Typography>
                <Typography sx={sx} variant="body1">
                    <BlockQuote imgSrc={imgUrl}>
                        {listItems[currentLink].quote}
                    </BlockQuote>
                    {listItems[currentLink].content[0]}
                </Typography>
                {listItems[currentLink].content
                    .slice(1)
                    .map((text: string, i: number) => (
                        <Typography sx={sx} variant="body1" key={"text" + i}>
                            {text}
                        </Typography>
                    ))}
            </Grid>
        </Grid>
    );
};

export default ListSlide;